export default "__VITE_ASSET__BFEqqQAA__"